import request from '@/utils/request'

export function login (data) {
  return request({
    url: '/common/token/create/',
    method: 'post',
    data
  })
}

export function wxLogin (data) {
  return request({
    url: '/common/wx/token/create/',
    method: 'post',
    data
  })
}

export function getUserInfo () {
  return request({
    url: '/front/user/info/',
    method: 'get'
  })
}

export function editUserInfo (data) {
  return request({
    url: '/front/user/update/',
    method: 'patch',
    data
  })
}

export function sendSms (query) {
  return request({
    url: '/front/send/sms/',
    method: 'get',
    params: query
  })
}

export function bindMobile (data) {
  return request({
    url: '/front/bind/mobile/',
    method: 'post',
    data
  })
}
